import React from 'react';
import { Check } from 'lucide-react';
import type { CuppingSessionDetail } from '../../../types/cuppingSession';

interface CuppingSessionTabsProps {
  details: CuppingSessionDetail[];
  activeId: string;
  onChange: (id: string) => void;
  blindMode?: boolean;
  completedIds: Set<string>;
  dataTestId: string;
}

const getLastThree = (value: string) => {
  if (!value) return '-';
  const trimmed = value.replace(/\s+/g, '');
  return trimmed.slice(-3);
};

export const CuppingSessionTabs: React.FC<CuppingSessionTabsProps> = ({
  details,
  activeId,
  onChange,
  blindMode,
  completedIds,
  dataTestId,
}) => {
  return (
    <div className="flex min-w-max whitespace-nowrap" data-test-id={dataTestId}>
      {details.map((detail, index) => {
        const label = blindMode ? detail.blindCode || `Code ${index + 1}` : getLastThree(detail.workOrderNumber);
        const isActive = activeId === detail.inventoryItemId;
        const isCompleted = completedIds.has(detail.inventoryItemId);
        return (
          <button
            key={detail.inventoryItemId}
            type="button"
            data-test-id={`cupping-session-tab-${detail.inventoryItemId}`}
            data-tab-index={index}
            data-completed={isCompleted ? 'true' : 'false'}
            data-active={isActive ? 'true' : 'false'}
            onClick={() => onChange(detail.inventoryItemId)}
            className={`inline-flex items-center px-3 py-1.5 rounded-md border text-xs font-semibold transition ${
              isActive
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-white text-gray-700 border-gray-200 hover:border-primary-400'
            }`}
          >
            <span>{label}</span>
            {isCompleted && (
              <span className="flex items-center justify-center h-4 w-4 rounded-full bg-white/20">
                <Check className={`h-3 w-3 ${isActive ? 'text-white' : 'text-primary-600'}`} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
